import React from 'react';
import QRDetailPage from './QRDetailPage.jsx';
import PublicQRView from './PublicQRView.jsx';

const QRViewRouter = () => {
  // Check if user is authenticated (has a valid token)
  const token = localStorage.getItem('token');
  const isAuthenticated = !!token;

  // If user is authenticated (admin), show the full admin QR detail page
  // If not authenticated (public user), show the simplified public view
  return isAuthenticated ? <QRDetailPage /> : <PublicQRView />;
};

export default QRViewRouter; 